export default __webpack_public_path__ + "static/media/misc.b269589e.png";